<template>
  <transition name="filter-popup-fade">
    <section class="history-container" v-if="visible">
      <template v-if="historyList.length">
        <p class="title">
          <span class="word history"></span>
          <a class="delete" @click="handleDeleteHis">
            <i class="iconfont icon-qingchu"></i>清空
          </a>
        </p>
        <dl class="history-list">
          <template v-for="(item,index) in historyList">
            <dd class="item" :key="index" @click="handleHisSearch(item.value)" v-if="index <= 9">{{item.value}}</dd>
          </template>
        </dl>
      </template>

      <p class="title">
        <span class="word hot"></span>
      </p>
      <ul class="top-search-list">
        <li
          class="item"
          v-for="(item,index) in hotList"
          :key="index"
          :class="[index>=3 ? 'notop':'']"
          @click="handleHisSearch(item.key)">
          <div class="text ellipsis-1">{{item.key}}</div>
        </li>
      </ul>
    </section>
  </transition>
</template>

<script>
import {
  getSerachHistoryList,
  getHotSearchList,
  addSearchHistory,
  delAllSearchHistory,
} from "@/api/distribution";

export default {
  data() {
    return {
      historyList: [],
      hotList: [],
      params: {},
      type: this.$route.params.type === 'knowledge' ? '1' : '2'
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    //获取历史搜索
    loadHistoryList() {
      getSerachHistoryList({type: this.type}).then((res) => {
        this.historyList = res.data || [];
      });
    },
    //获取热搜
    loadHotList() {
      getHotSearchList({type: this.type}).then((res) => {
        this.hotList = res.data || [];
      });
    },
    //点击历史搜索
    handleHisSearch(text) {
      this.addToHistory(text);
      this.$emit("searchHis", text);
    },
    //添加到历史搜索中
    addToHistory(text) {
      const param = {
        type: 2,
        value: text,
      };
      addSearchHistory(param, (res) => {
        this.loadHistoryList();
      });
    },
    // 清空历史搜索记录
    handleDeleteHis() {
      delAllSearchHistory().then((res) => {
        this.loadHistoryList();
      });
    },
  },
  mounted() {
    this.params = { type: this.$route.params.type }
    this.loadHistoryList();
    this.loadHotList();

  },
};
</script>
<style lang="scss">
.history-container {
  // position: fixed;
  // top: 40px;
  // bottom: 54px;
  // width: 100%;
  // background-color: #fff;
  // z-index: 999;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
  padding: 0 30px;
  box-sizing: border-box;

  .title {
    font-size: 36px;
    color: $heading-color;
    margin-top: 25px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .word{
    width: 116px;
    height: 23px;

    &.history{
      background: url('../../../assets/imgs/img_search_history.svg') no-repeat;
      background-size: 100% auto;
    }
    &.hot{
      background: url('../../../assets/imgs/img_search_hot.svg') no-repeat;
      background-size: 100% auto;
    }
  }
  .delete {
    font-size: 24px;
    color: #949999;

    .icon-qingchu{
      font-size: 24px;
      margin-right: 5px;
    }
  }
  .history-list {
    display: flex;
    flex-wrap: wrap;

    .item {
      max-width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 48px;
      line-height: 48px;
      padding: 0 24px;
      border-radius: 48px;
      color: #949999;
      font-size: 24px;
      background-color: #f2f2f2;
      margin-right: 16px;
      margin-bottom: 16px;
      cursor: pointer;
    }
  }
  .empty-text {
    text-align: center;
    font-size: 24px;
    color: $text-color;
  }
  .top-search-list {
    display: flex;
    flex-wrap: wrap;

    .item {
      height: 48px;
      display: flex;
      align-items: center;
      padding: 0 24px;
      border-radius: 48px;
      color: #949999;
      font-size: 24px;
      border: 1px solid #E1E1E6;
      margin-right: 16px;
      margin-bottom: 16px;
      cursor: pointer;
      position: relative;

      &:nth-child(-n + 3) {
        &::before{
          content: '';
          width: 51px;
          height: 13px;
          background: url('../../../assets/imgs/icon_search_hot.svg') no-repeat;
          background-size: cover;
          display: inline-block;
        }
        .text{
          position: relative;
          display: inline-flex;
          align-items: center;

          &::before{
            content: '';
            display: inline-block;
            width: 1px;
            height: 10px;
            margin: 0 10px;
            background-color: #E1E1E6;
          }
        }
      }
    }
    .text {
      max-width: 320px;
      flex: 1;
      font-size: 28px;
      color: #636666;
    }
  }
}
</style>